export default {
  "en": {
    "signature": {
      "actions": {
        "clearSignature": "Clear signature",
        "edit": "Edit",
        "request": "Request signature",
        "save": "Save",
        "sign": "Sign"
      },
      "labels": {
        "add": "Add",
        "add_customer_signatures": "You must add customer signatures before saving.",
        "add_team_member_signatures": "You must add signatures for team members before saving.",
        "all_customers_signed": "All requested homebuyers have already signed. The documents still need to be signed by {client_name} representatives and the proposal will be approved once they sign them. No further action is required on your side.",
        "browserNotSupported": "We detected that your mobile browser might not support electronic signatures. If you experience any problems, please switch browsers or device, or upload a signed document instead.",
        "customer_signatories": "Customer signatories",
        "customers_left_to_sign": "1 customer needs to sign | {customers_left_to_sign} customers need to sign",
        "customers_required_to_sign": "1 more homebuyer needs to sign the documents. | {customers_left_to_sign} more homebuyers need to sign the documents.",
        "customers_signed_names": "Customers already signed: {names}",
        "documents_read": "I have read all documents and wish to sign them.",
        "documents_to_sign": "Documents to sign",
        "draw_signature": "Draw your signature below",
        "employee_signatories": "{client_name} signatories",
        "employees_required_to_sign": "1 more team member needs to sign the documents. | {employees_left_to_sign} more team members need to sign the documents",
        "employees_signed_names": "Team members already signed: {names}",
        "empty_signature_warning": "Please draw your signature first.",
        "marked": "Signature position marked",
        "multiple_signatories_info": "This document will be signed by multiple signatories. Please, fill your name before signing so {client_name} can keep track of who has signed.",
        "next": "Next",
        "no_signature_indicators_warning": "Please indicate where the document needs to be signed, by clicking on the page(s).",
        "ok": "OK",
        "original": "Original",
        "page": "page",
        "place_signature_subtitle": "Click on the page(s) where you need the customer to sign electronically",
        "place_signature_title": "Mark where to sign",
        "read_documents": "Please read the following documents before signing them",
        "remove": "Remove",
        "requesting_signage": "Requesting signage from",
        "sign": "Sign",
        "signatories_for_all_documents": "Number of signatories applies for all documents. Changing it will remove all signatures and you'll have to add them again.",
        "signatureNotPossible": "Electronic signatures are not available for this file type",
        "signatures_pending_from_client": "Signatures pending from {client_name} team",
        "signed": "Signed",
        "signed_progress": "Signed: {already_signed_count} out of {all_required_to_sign_count}",
        "specifyWhereToSign": "Mark where to sign",
        "team_member": "Team member",
        "team_member_signature_warning": "You will be able to request signage from team members after you've requested signage from customers.",
        "thank_you_for_signing": "Thank you for signing.",
        "toBeSigned": "To be signed"
      }
    }
  }
}